import { useCallback } from "react";

import { viewModelToInput } from "./converter";
import { useSiteControllerSettingNeppanMutation } from "../../repository";

import type { SiteControllerSettingNeppanFormModel } from "../../type";

type Props = {
	viewModel: SiteControllerSettingNeppanFormModel["ViewModel"];
};

export const useUpdateSiteControllerSettingNeppan = ({ viewModel }: Props) => {
	const { onUpdate: _onUpdate } = useSiteControllerSettingNeppanMutation();
	const onUpdate = useCallback(async () => {
		const input = viewModelToInput({ viewModel });
		return await _onUpdate({ input });
	}, [_onUpdate, viewModel]);

	return {
		onUpdate,
	};
};
